import LazyImage from "../../../LazyImage";
import { CREHANA_TEXT_IMAGE } from "../constants/image-constants";
import { jsx as _jsx } from "react/jsx-runtime";
var CrehanaTextImage = function CrehanaTextImage() {
  return /*#__PURE__*/_jsx(LazyImage, {
    alt: "Crehana",
    src: CREHANA_TEXT_IMAGE,
    imgxParams: {
      fit: 'clip',
      w: 64,
      h: 12,
      q: 100
    },
    isTransparent: true,
    className: "tw-w-6.4 tw-h-1.2 tw-fill-current"
  });
};
export default CrehanaTextImage;